import WaitingIndicator from "../waiting-indicator/waiting-indicator";

interface IButtonLoaderProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	loading: boolean;
}

const ButtonLoader: React.FC<IButtonLoaderProps> = ({
	loading,
	children,
	...rest
}) => {
	return (
		<button
			disabled={loading}
			style={{ position: 'relative' }}
			{...rest}
		>
			{loading ? (
				<>
					<div style={{
						position: 'absolute',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100%',
						width: '100%',
						top: '0',
						left: '0',
					}}>
						<WaitingIndicator />
					</div>
					<div style={{ visibility: 'hidden' }}>{children}</div>
				</>
			) : children}
		</button>
	);
};

export default ButtonLoader;
